// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__otfWP","flareAnimation":"UpButton_flareAnimation__8ar-R"};